import React, { useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

const SyncTerm = (props) => {
  const [syncing, setSyncing] = useState(false);
  const [report, setReport] = useState('');

  const syncTerm = () => {
    setReport('');
    setSyncing(true);
    axios.get(`/admin/terms/${props.term_id}/sync_term_data`)
    .then(response => {
      setSyncing(false);
      setReport('Synchornizováno');
    }).catch(error => {
      setSyncing(false);
      setReport('Chyba ' + error.response.data.error);
    });
  }

  const syncRatings = () => {
    setReport('');
    setSyncing(true);
    axios.get(`/admin/terms/${props.term_id}/sync_ratings`)
      .then(response => {
        setSyncing(false);
        setReport('Synchornizováno');
      }).catch(error => {
      setSyncing(false);
    });
  }

  return (
    <div className="mt-1">
      {syncing &&
      <i className="fas fa-spinner fa-pulse text-primary" />
      }
      <button onClick={syncTerm} className="pointer-cursor" disabled={syncing}>Synchronizovat s PL</button>
      <span className="mr-1" />
      <button onClick={syncRatings} className="pointer-cursor" disabled={syncing}>Synchronizovat recenze</button>
      <br />
      <small className="text-danger">{report}</small>
    </div>
  );
}

SyncTerm.propTypes = {
  term_id: PropTypes.number.isRequired
}

export default SyncTerm;
